import RefinanceLayout from "./RefinanceLayout";
import RefinanceListPage from "./pages/RefinanceListPage";
import RefinanceDetailPage from "./pages/RefinanceDetailPage";

export const refinanceRoutes = {
  path: "refinance",
  component: RefinanceLayout,
  children: [
    {
      name: "RefinanceListPage",
      component: RefinanceListPage,
      path: ""
    },
    {
      name: "RefinanceDetailPage",
      component: RefinanceDetailPage,
      path: ":id"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/features/refinance/routes.js